import { RemoveRemoteParticipantInteractor } from "../../../interactors";
import { SignalingMessageDisconnect } from "../../../services";
import { BaseStreamingCommand } from "./BaseStreamingCommand";

export class DisconnectionCommand extends BaseStreamingCommand {
  public execute(e: unknown): void {
    const event = e as CustomEvent<SignalingMessageDisconnect>;
    const message = event.detail;
    const removeRemoteParticipant = RemoveRemoteParticipantInteractor.create();
    const room = removeRemoteParticipant.execute({
      remoteId: message.data.user.id,
      room: this.getRoom()
    });
    this.bloc.changeState({
      ...this.bloc.state,
      room
    });
    this.bloc.handleNotification({
      header: "Disconnessione",
      body: `${message.data.user.username} ha lasciato la stanza`
    });
  }
}
